import { render, staticRenderFns } from "./skillScoreRadios.vue?vue&type=template&id=3216d6ad&scoped=true&"
import script from "./skillScoreRadios.vue?vue&type=script&lang=js&"
export * from "./skillScoreRadios.vue?vue&type=script&lang=js&"
import style0 from "./skillScoreRadios.vue?vue&type=style&index=0&id=3216d6ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3216d6ad",
  null
  
)

export default component.exports